import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  container: {
    position: 'fixed',
    pointerEvents: 'none',
    left: 0,
    top: 0,
    zIndex: 100,
    width: '100%',
    height: '100%'
  },
  countContainer: {
    letterSpacing: -1,
    fontFamily: 'verdana',
    marginLeft: -1,
    color: '#fff',
    fontWeight: 600
  },
  copy: {
    display: 'block',
    background: '#66CD00',
    width: 13,
    height: 13,
    lineHeight: '13px',
    fontWeight: 'bold',
    color: '#fff',
    borderRadius: '50%',
    position: 'absolute'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Media/DragLayer/styles.js